import { Injectable } from '@angular/core';
import { TranslateService } from '../../../api/translate.service';
import {
  fieldAdditionalFeeTypesCol,
  fieldAddressLine1Col,
  fieldAddressLine2Col,
  fieldAmountCol,
  fieldApprovedByCol,
  fieldBooleanCol,
  fieldBuildingNameCol,
  fieldCarParkSpacesCol,
  fieldConfidentialityStatusCol,
  fieldContractTypeCol,
  fieldCounterPartyCol,
  fieldCountryCol,
  fieldCreatedByCol,
  fieldCurrencyCol,
  fieldCustomerNameCol,
  fieldDateCol,
  fieldDealTypeAgileSpaceCol,
  fieldDistrictCol,
  fieldFloorCol,
  fieldGridIdCol,
  fieldIdCol,
  fieldInvoiceIdCol,
  fieldInvoiceTypeCol,
  fieldLocalityCol,
  fieldMiqIdCol,
  fieldNoticeOfCancellationInMonthsCol,
  fieldOppNumberCol,
  fieldOpportunityCol,
  fieldOpportunityInstallmentCol,
  fieldOpportunitySourceCol,
  fieldOptionToRenewTheLeaseCol,
  fieldPctCol,
  fieldPostcodeCol,
  fieldPrimaryEmployeeFunctionalUnitCol,
  fieldPrimaryEmployeeFunctionalUnitIdCol,
  fieldPrimaryEmployeeIdCol,
  fieldPrimaryEmployeeManagingOfficeCol,
  fieldPrimaryEmployeeManagingOfficeIdCol,
  fieldPrimaryEmployeeNameCol,
  fieldPropertyAreaCol,
  fieldPropertyManagedCol,
  fieldPropertySubtypeCol,
  fieldPropertyTypeCol,
  fieldPropertyTypeSpaceLabelCol,
  fieldRegionCol,
  fieldRepresentedPartyCol,
  fieldRepRolCol,
  fieldSizeAreaMeasureCol,
  fieldSpaceConditionCol,
  fieldSubmittedByCol,
  fieldSuburbCol,
  fieldSuiteCol,
  fieldSupplierTypeCol,
  fieldTeamCol,
  fieldTenantBankGuaranteeAmountCol,
  fieldTenantSecurityDepositAmountCol,
  fieldTextCol,
  fieldTransactionTypeCol,
  fieldTransSubtypeCol
} from '../../../utils/ag-grid/column-defs';
import { ColDef } from 'ag-grid-community';

@Injectable({
  providedIn: 'root'
})
export class LeaseFeeCalculationReportService {

  constructor(private translateService: TranslateService) { }

  getHeaders(settings: { middle: any, left: any, right: any }) {
    return [
      {
        header: this.translateService.getTranslation('FINISHLINE_ID'),
        key: 'finishline_id',
        width: 7,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_ID'),
        key: 'invoice_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('TRANSACTION_TYPE'),
        key: 'transaction_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_DT'),
        key: 'invoiced_time',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_TYPE'),
        key: 'invoice_type',
        width: 10,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('TEAM_ID'),
        key: 'team',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CURRENCY'),
        key: 'currency',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_NO'),
        key: 'opportunity_number',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_ID'),
        key: 'opportunity',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_INSTALLMENT_ID'),
        key: 'opportunity_installment_id',
        width: 30,
        style: { ...settings.middle },
      },

      {
        header: this.translateService.getTranslation('OPPORTUNITY_SOURCE'),
        key: 'opportunity_source',
        width: 30,
        style: { ...settings.middle },
      }
      ,
      {
        header: this.translateService.getTranslation('TRANSACTION_SUBTYPE'),
        key: 'subtype',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('LEASE_EXECUTED_DATE'),
        key: 'execution_date',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OCCUPATION_DATE'),
        key: 'occupation_date',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('DEAL_TYPE_AGILE_SPACE'),
        key: 'deal_type_agile_space',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('LEASE_FROM_DATE'),
        key: 'start_date',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('LEASE_TO_DATE'),
        key: 'end_date',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('ABSORPTION_DATE'),
        key: 'absorbtion_date',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('EARLY_TERMINATION_DATE'),
        key: 'early_termination_date',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('IS_THERE_AN_OPTION_TO_RENEW'),
        key: 'option_to_renew_the_lease',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('NOTICE_OF_CANCELLATION'),
        key: 'notice_of_cancellation_in_months',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('BANK_GUARANTEE_AMOUNT'),
        key: 'tenant_bank_guarentee_amount',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('SECURITY_DEPOSIT_AMOUNT'),
        key: 'tenant_security_deposit_amount',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CONTRACT_TYPE'),
        key: 'contract_type',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('MIQ_PROPERTY_ID'),
        key: 'miq_property_id',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PROPERTY_GRID_ID'),
        key: 'property_grid_id',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('BUILDING_NAME'),
        key: 'building_name',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('ADDRESS_LINE1'),
        key: 'address_line1',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('ADDRESS_LINE2'),
        key: 'address_line2',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('POSTAL_CODE'),
        key: 'postal_code',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('SUBURB'),
        key: 'suburb',
        width: 16,
        style: { ...settings.left },
      },
      {
        header: this.translateService.getTranslation('DISTRICT'),
        key: 'district',
        width: 16,
        style: { ...settings.left },
      },
      {
        header: this.translateService.getTranslation('LOCALITY'),
        key: 'locality',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('REGION'),
        key: 'region',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('COUNTRY'),
        key: 'country',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PROPERTY_TYPE'),
        key: 'property_type',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PROPERTY_SUBTYPE'),
        key: 'property_subtype',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PROPERTY_TYPE_SPACE'),
        key: 'property_type_space',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('SPACE_CONDITION'),
        key: 'space_condition',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PROPERTY_AREA'),
        key: 'property_area',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('SIZE_AREA_MEASURE'),
        key: 'size_area_measure',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CALCULATION_METRIC_DESKS'),
        key: 'desks',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CALCULATION_METRIC_RACKS'),
        key: 'racks',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CALCULATION_METRIC_SERVERS'),
        key: 'servers',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CALCULATION_METRIC_MEGAWATTS'),
        key: 'megawatts',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CALCULATION_METRIC_KILOWATTS'),
        key: 'kilowatts',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CAR_PARK_SPACES'),
        key: 'car_park_spaces',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('FLOOR'),
        key: 'floor',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('SUITE'),
        key: 'suite',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('MANAGED_BY_CBRE'),
        key: 'managed_by_cbre',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_ID').toUpperCase(),
        key: 'primary_employee_id',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_NAME').toUpperCase(),
        key: 'primary_employee_name',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_ID').toUpperCase(),
        key: 'primary_employee_functional_unit_id',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_DESC').toUpperCase(),
        key: 'primary_employee_functional_unit',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_ID').toUpperCase(),
        key: 'primary_employee_managing_office_id',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_DESC').toUpperCase(),
        key: 'primary_employee_managing_office',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('REP_ROLE'),
        key: 'rep_role',
        width: 10,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('REPRESENTED_PARTY'),
        key: 'customer_name',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('SUPPLIER_TYPE').toUpperCase(),
        key: 'supplier_type',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('COUNTER_PARTY_NAME'),
        key: 'counter_party_name',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('BILL_TO_CUST'),
        key: 'bill_to_customer_name',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('TENANT'),
        key: 'tenant',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('LANDLORD'),
        key: 'landlord',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('COUNTER_PARTY_1'),
        key: 'counter_party_rep1',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('COUNTER_PARTY_2'),
        key: 'counter_party_rep2',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('COUNTER_PARTY_3'),
        key: 'counter_party_rep3',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('GROSS_FEE_INCLUDE_OUTGOINS'),
        key: 'gross_fee_include_outgoings',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('ANNUAL_AVG_RENT_CALCULATION'),
        key: 'annual_avg_rent_calculation',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('GROSS_INCENTIVE_INCLUDE_OUTGOINS'),
        key: 'gross_incentive_includes_outgoings',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('INCLUDE_INCENTIVE_AMOUNT_CHECK'),
        key: 'incentive_amt_included_in_fee_calc',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('FEE_RATE'),
        key: 'fee_rate',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('RENT_RATE'),
        key: 'rent_rate',
        width: 15,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('OUTGOINGS'),
        key: 'outgoings',
        width: 15,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('TOTAL_SIZE_MEASUREMENT'),
        key: 'calculation_metric',
        width: 15,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('ANNUAL_RENT'),
        key: 'aarc_annual_rent_per_size',
        width: 15,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('RENT_INCREASE'),
        key: 'aarc_rent_increase',
        width: 15,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('AARC_ANNUAL_OUTGOINGS_PER_SIZE'),
        key: 'aarc_annual_outgoings_per_size',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('MONTHS'),
        key: 'aarc_months',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('TOTAL_MONTHS_OF_LEASE'),
        key: 'aarc_total_months_of_lease',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('AARC_ANNUAL_CAR_PARK'),
        key: 'aarc_annual_car_park',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('AARC_FREE_RENT'),
        key: 'aarc_incentive',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('ANNUAL_TRANSACTION_AMOUNT'),
        key: 'aarc_annual_transaction_amt',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('AARC_FEE_RATE'),
        key: 'aarc_fee_rate',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('ANNUAL_CBRE_FEE'),
        key: 'aarc_annual_cbre_gross_fee',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('AVG_TRANS_AMT'),
        key: 'aarc_avg_transaction_amt',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('AVG_FEE_RATE'),
        key: 'aarc_avg_fee_rate',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('AVG_CBRE_FEES'),
        key: 'aarc_avg_cbre_gross_fee',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('RENT_PER_SIZE'),
        key: 'annual_rent_per_size',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('ANNUAL_OUTGOING'),
        key: 'annual_outgoings_per_size',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('ANNUAL_CAR_PARK'),
        key: 'annual_car_park',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('FREE_RENT'),
        key: 'incentive',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('TRANSACTION_AMOUNT'),
        key: 'transaction_amount',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('FEE_RATE'),
        key: 'fee_rate2',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('GROSS_FEES'),
        key: 'cbre_fee',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('LEASE_FEE_TYPE'),
        key: 'additional_fee_types',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('FEE_AMOUNT'),
        key: 'additional_fee_total',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('FEE_AMOUNT_TRANSCTION_AMOUNT'),
        key: 'additional_fee_trans_amount',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('LEASE_TOTAL_FEE'),
        key: 'total_fee',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('INSTALLMENT_BILLING_AMOUNT'),
        key: 'less_installment_billing_amount',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CONJUNCTIONAL_AGENT_FEE_AMOUNT'),
        key: 'less_conjunctional_agent_fee',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('LEASE_TOTAL_CBRE_FEE'),
        key: 'lease_total_cbre_fee',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CREATED_BY'),
        key: 'created_by',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SUBMITTED_BY'),
        key: 'submitted_by',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('APPROVED_BY'),
        key: 'approved_by',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CONFIDENTIALITY_STATUS'),
        key: 'confidentiality_status',
        width: 30,
        style: { ...settings.middle },
      }
    ];
  }

  getDataSourceSettings(): ColDef[] {
    return [
      {
        ...fieldIdCol,
        field: 'finishline_id',
        headerName: this.translateService.getTranslation('FINISHLINE_ID'),
      },
      {
        ...fieldInvoiceIdCol,
        field: 'invoice_id',
        headerName: this.translateService.getTranslation('INVOICE_ID'),
        cellRenderer: null,
      },      
      {
        ...fieldTransactionTypeCol,
        headerName: this.translateService.getTranslation('TRANSACTION_TYPE'),
      },  
      {
        ...fieldDateCol,
        field: 'invoiced_time',
        headerName: this.translateService.getTranslation('INVOICE_DT'),
      },      
      {
        ...fieldInvoiceTypeCol,
        headerName: this.translateService.getTranslation('INVOICE_TYPE'),
      },      
      {
        ...fieldTeamCol,
        headerName: this.translateService.getTranslation('TEAM_ID'),
      },       
      {
        ...fieldCurrencyCol,
        headerName: this.translateService.getTranslation('CURRENCY'),
      },     
      {
        ...fieldOppNumberCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_NO'),
      },      
      {
        ...fieldOpportunityCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_ID'),
      },     
      {
        ...fieldOpportunityInstallmentCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_INSTALLMENT_ID'),
      }, 
      {
        ...fieldOpportunitySourceCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_SOURCE'),
      },        
      {
        ...fieldTransSubtypeCol,
        field: 'subtype',
        headerName: this.translateService.getTranslation('TRANSACTION_SUBTYPE'),
      },
      {
        ...fieldDateCol,
        field: 'execution_date',
        headerName: this.translateService.getTranslation('LEASE_EXECUTED_DATE'),
      }, 
      {
        ...fieldDateCol,
        field: 'occupation_date',
        headerName: this.translateService.getTranslation('OCCUPATION_DATE'),
      },              
      {
        ...fieldDealTypeAgileSpaceCol,
        headerName: this.translateService.getTranslation('DEAL_TYPE_AGILE_SPACE'),
      },
      {
        ...fieldDateCol,
        field: 'start_date',
        headerName: this.translateService.getTranslation('LEASE_FROM_DATE'),
      }, 
      {
        ...fieldDateCol,
        field: 'end_date',
        headerName: this.translateService.getTranslation('LEASE_TO_DATE'),
      },
      {
        ...fieldDateCol,
        field: 'absorbtion_date',
        headerName: this.translateService.getTranslation('ABSORPTION_DATE'),
      },
      {
        ...fieldDateCol,
        field: 'early_termination_date',
        headerName: this.translateService.getTranslation('EARLY_TERMINATION_DATE'),
      },       
      {
        ...fieldOptionToRenewTheLeaseCol,
        headerName: this.translateService.getTranslation('IS_THERE_AN_OPTION_TO_RENEW'),
      },
      {
        ...fieldNoticeOfCancellationInMonthsCol,
        headerName: this.translateService.getTranslation('NOTICE_OF_CANCELLATION'),
      },
      {
        ...fieldTenantBankGuaranteeAmountCol,
        headerName: this.translateService.getTranslation('BANK_GUARANTEE_AMOUNT'),
      },
      {
        ...fieldTenantSecurityDepositAmountCol,
        headerName: this.translateService.getTranslation('SECURITY_DEPOSIT_AMOUNT'),
      },
      {
        ...fieldContractTypeCol,
        headerName: this.translateService.getTranslation('CONTRACT_TYPE'),
      },
      {
        ...fieldMiqIdCol,
        headerName: this.translateService.getTranslation('MIQ_PROPERTY_ID'),
      },        
      {
        ...fieldGridIdCol,
        field: 'property_grid_id',
        headerName: this.translateService.getTranslation('PROPERTY_GRID_ID'),
      },
      {
        ...fieldBuildingNameCol,
        headerName: this.translateService.getTranslation('BUILDING_NAME'),
      },         
      {
        ...fieldAddressLine1Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE1'),
      },      
      {
        ...fieldAddressLine2Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE2'),
      },        
      {
        ...fieldPostcodeCol,
        headerName: this.translateService.getTranslation('POSTAL_CODE'),
      },    
      {
        ...fieldSuburbCol,
        headerName: this.translateService.getTranslation('SUBURB'),
      },      
      {
        ...fieldDistrictCol,
        headerName: this.translateService.getTranslation('DISTRICT'),
      },       
      {
        ...fieldLocalityCol,
        headerName: this.translateService.getTranslation('LOCALITY'),
      },   
      {
        ...fieldRegionCol,
        headerName: this.translateService.getTranslation('REGION'),
      },              
      {
        ...fieldCountryCol,
        headerName: this.translateService.getTranslation('COUNTRY'),
      },   
      {
        ...fieldPropertyTypeCol,
        headerName: this.translateService.getTranslation('PROPERTY_TYPE'),
      },         
      {
        ...fieldPropertySubtypeCol,
        headerName: this.translateService.getTranslation('PROPERTY_SUBTYPE'),
      },
      {
        ...fieldPropertyTypeSpaceLabelCol,
        headerName: this.translateService.getTranslation('PROPERTY_TYPE_SPACE'),
      },
      {
        ...fieldSpaceConditionCol,
        headerName: this.translateService.getTranslation('SPACE_CONDITION'),
      },
      {
        ...fieldPropertyAreaCol,
        headerName: this.translateService.getTranslation('PROPERTY_AREA'),
      },
      {
        ...fieldSizeAreaMeasureCol,
        headerName: this.translateService.getTranslation('SIZE_AREA_MEASURE'),
      },
      {
        ...fieldPropertyAreaCol,
        field: 'desks',
        headerName: this.translateService.getTranslation('CALCULATION_METRIC_DESKS'),
      },
      {
        ...fieldPropertyAreaCol,
        field: 'racks',
        headerName: this.translateService.getTranslation('CALCULATION_METRIC_RACKS'),
      },   
      {
        ...fieldPropertyAreaCol,
        field: 'servers',
        headerName: this.translateService.getTranslation('CALCULATION_METRIC_SERVERS'),
      },
      {
        ...fieldPropertyAreaCol,
        field: 'megawatts',
        headerName: this.translateService.getTranslation('CALCULATION_METRIC_MEGAWATTS'),
      },
      {
        ...fieldPropertyAreaCol,
        field: 'kilowatts',
        headerName: this.translateService.getTranslation('CALCULATION_METRIC_KILOWATTS'),
      },        
      {
        ...fieldCarParkSpacesCol,
        headerName: this.translateService.getTranslation('CAR_PARK_SPACES'),
      },      
      {
        ...fieldFloorCol,
        headerName: this.translateService.getTranslation('FLOOR'),
      },  
      {
        ...fieldSuiteCol,
        headerName: this.translateService.getTranslation('SUITE'),
      },   
      {
        ...fieldPropertyManagedCol,
        headerName: this.translateService.getTranslation('MANAGED_BY_CBRE'),
      },
      {
        ...fieldPrimaryEmployeeIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_ID'),
      },
      {
        ...fieldPrimaryEmployeeNameCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_NAME'),
      },
      {
        ...fieldPrimaryEmployeeFunctionalUnitIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_ID'),
      },
      {
        ...fieldPrimaryEmployeeFunctionalUnitCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_DESC'),
      },              
      {
        ...fieldPrimaryEmployeeManagingOfficeIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_ID'),
      },
      {
        ...fieldPrimaryEmployeeManagingOfficeCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_DESC'),
      },   
      {
        ...fieldRepRolCol,
        field: 'rep_role',
        headerName: this.translateService.getTranslation('REP_ROLE'),
      },              
      {
        ...fieldRepresentedPartyCol,
        field: 'customer_name',
        headerName: this.translateService.getTranslation('REPRESENTED_PARTY'),
      },    
      {
        ...fieldSupplierTypeCol,
        headerName: this.translateService.getTranslation('SUPPLIER_TYPE'),
      },
      {
        ...fieldCounterPartyCol,
        headerName: this.translateService.getTranslation('COUNTER_PARTY_NAME'),
      },        
      {
        ...fieldCustomerNameCol,
        field: 'bill_to_customer_name',
        headerName: this.translateService.getTranslation('BILL_TO_CUST'),
      },      
      {
        ...fieldRepRolCol,
        field: 'tenant',
        headerName: this.translateService.getTranslation('TENANT'),
      },
      {
        ...fieldRepRolCol,
        field: 'landlord',
        headerName: this.translateService.getTranslation('LANDLORD'),
      },        
      {
        ...fieldCounterPartyCol,
        field: 'counter_party_rep1',
        minWidth: 250,
        headerName: this.translateService.getTranslation('COUNTER_PARTY_1'),
      },  
      {
        ...fieldCounterPartyCol,
        field: 'counter_party_rep2',
        minWidth: 250,
        headerName: this.translateService.getTranslation('COUNTER_PARTY_2'),
      },  
      {
        ...fieldCounterPartyCol,
        field: 'counter_party_rep3',
        minWidth: 250,
        headerName: this.translateService.getTranslation('COUNTER_PARTY_3'),
      },   
      {
        ...fieldBooleanCol,
        headerName: this.translateService.getTranslation('GROSS_FEE_INCLUDE_OUTGOINS'),
      },
      {
        ...fieldBooleanCol,
        field: 'annual_avg_rent_calculation',
        headerName: this.translateService.getTranslation('ANNUAL_AVG_RENT_CALCULATION'),
      },
      {
        ...fieldBooleanCol,
        field: 'gross_incentive_includes_outgoings',
        headerName: this.translateService.getTranslation('GROSS_INCENTIVE_INCLUDE_OUTGOINS'),
      },
      {
        ...fieldBooleanCol,
        field: 'incentive_amt_included_in_fee_calc',
        headerName: this.translateService.getTranslation('INCLUDE_INCENTIVE_AMOUNT_CHECK'),
      },             
      {
        ...fieldTextCol,
        field: 'fee_rate',
        headerName: this.translateService.getTranslation('FEE_RATE'),
      },
      {
        ...fieldTextCol,
        field: 'rent_rate',
        headerName: this.translateService.getTranslation('RENT_RATE'),
      },
      {
        ...fieldTextCol,
        field: 'outgoings',
        headerName: this.translateService.getTranslation('OUTGOINGS'),
      },
      {
        ...fieldSizeAreaMeasureCol,
        field: 'calculation_metric',
        headerName: this.translateService.getTranslation('TOTAL_SIZE_MEASUREMENT'),
      },
      {
        ...fieldAmountCol,
        field: 'aarc_annual_rent_per_size',
        headerName: this.translateService.getTranslation('ANNUAL_RENT'),
      },
      {
        ...fieldPctCol,
        field: 'aarc_rent_increase',
        headerName: this.translateService.getTranslation('RENT_INCREASE'),
      },   
      {
        ...fieldAmountCol,
        field: 'aarc_annual_outgoings_per_size',
        headerName: this.translateService.getTranslation('AARC_ANNUAL_OUTGOINGS_PER_SIZE'),
      },         
      {
        ...fieldNoticeOfCancellationInMonthsCol,
        field: 'aarc_months',
        headerName: this.translateService.getTranslation('MONTHS'),
      },
      {
        ...fieldNoticeOfCancellationInMonthsCol,
        field: 'aarc_total_months_of_lease',
        headerName: this.translateService.getTranslation('TOTAL_MONTHS_OF_LEASE'),
      },
      {
        ...fieldAmountCol,
        field: 'aarc_annual_car_park',
        headerName: this.translateService.getTranslation('AARC_ANNUAL_CAR_PARK'),
      },
      {
        ...fieldAmountCol,
        field: 'aarc_incentive',
        headerName: this.translateService.getTranslation('AARC_FREE_RENT'),
      },
      {
        ...fieldAmountCol,
        field: 'aarc_annual_transaction_amt',
        headerName: this.translateService.getTranslation('ANNUAL_TRANSACTION_AMOUNT'),
      },
      {
        ...fieldPctCol,
        field: 'aarc_fee_rate',
        headerName: this.translateService.getTranslation('AARC_FEE_RATE'),
      },
      {
        ...fieldAmountCol,
        field: 'aarc_annual_cbre_gross_fee',
        headerName: this.translateService.getTranslation('ANNUAL_CBRE_FEE'),
      },
      {
        ...fieldAmountCol,
        field: 'aarc_avg_transaction_amt',
        headerName: this.translateService.getTranslation('AVG_TRANS_AMT'),
      },
      {
        ...fieldAmountCol,
        field: 'aarc_avg_fee_rate',
        headerName: this.translateService.getTranslation('AVG_FEE_RATE'),
      },
      {
        ...fieldAmountCol,
        field: 'aarc_avg_cbre_gross_fee',
        headerName: this.translateService.getTranslation('AVG_CBRE_FEES'),
      },
      {
        ...fieldAmountCol,
        field: 'annual_rent_per_size',
        headerName: this.translateService.getTranslation('RENT_PER_SIZE'),
      },
      {
        ...fieldAmountCol,
        field: 'annual_outgoings_per_size',
        headerName: this.translateService.getTranslation('ANNUAL_OUTGOING'),
      },
      {
        ...fieldAmountCol,
        field: 'annual_car_park',
        headerName: this.translateService.getTranslation('ANNUAL_CAR_PARK'),
      },
      {
        ...fieldAmountCol,
        field: 'incentive',
        headerName: this.translateService.getTranslation('FREE_RENT'),
      },
      {
        ...fieldAmountCol,
        field: 'transaction_amount',
        headerName: this.translateService.getTranslation('TRANSACTION_AMOUNT'),
      },
      {
        ...fieldPctCol,
        field: 'fee_rate2',
        headerName: this.translateService.getTranslation('FEE_RATE'),
      },
      {
        ...fieldAmountCol,
        field: 'cbre_fee',
        headerName: this.translateService.getTranslation('GROSS_FEES'),
      },
      {
        ...fieldAdditionalFeeTypesCol,
        headerName: this.translateService.getTranslation('LEASE_FEE_TYPE'),
      },
      {
        ...fieldAmountCol,
        field: 'additional_fee_total',
        headerName: this.translateService.getTranslation('FEE_AMOUNT'),
      },
      {
        ...fieldAmountCol,
        field: 'additional_fee_trans_amount',
        headerName: this.translateService.getTranslation('FEE_AMOUNT_TRANSCTION_AMOUNT'),
      },
      {
        ...fieldAmountCol,
        field: 'total_fee',
        headerName: this.translateService.getTranslation('LEASE_TOTAL_FEE'),
      },
      {
        ...fieldAmountCol,
        field: 'less_installment_billing_amount',
        headerName: this.translateService.getTranslation('INSTALLMENT_BILLING_AMOUNT'),
      },
      {
        ...fieldAmountCol,
        field: 'less_conjunctional_agent_fee',
        headerName: this.translateService.getTranslation('CONJUNCTIONAL_AGENT_FEE_AMOUNT'),
      },
      {
        ...fieldAmountCol,
        field: 'lease_total_cbre_fee',
        headerName: this.translateService.getTranslation('LEASE_TOTAL_CBRE_FEE'),
      },
      {
        ...fieldCreatedByCol,
        headerName: this.translateService.getTranslation('CREATED_BY'),
      },            
      {
        ...fieldSubmittedByCol,
        headerName: this.translateService.getTranslation('SUBMITTED_BY'),
      },     
      {
        ...fieldApprovedByCol,
        headerName: this.translateService.getTranslation('APPROVED_BY'),
      }, 
      {
        ...fieldConfidentialityStatusCol,
        headerName: this.translateService.getTranslation('CONFIDENTIALITY_STATUS'),
      }
    ];
  }
}
